import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Password, PasswordModule } from 'primeng/password';
import { MessagesModule } from 'primeng/messages';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [FormsModule, ToastModule, ButtonModule, InputTextModule, PasswordModule, MessagesModule, CommonModule],
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    providers: [MessageService]
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    email = '';
    oldPassword = '';
    newPassword = '';
    confirmPassword = '';
    msgs: any[] = [];
    loading: boolean = false;
    loaderMessageLine1 = 'Loading...';
    loaderMessageLine2 = 'Please wait...';

    @ViewChild('passwordInput') passwordInput!: Password;
    @ViewChild('passwordInputinputINIT') passwordInputinputINIT!: Password;

    showHelpdeskDialog = false;

    inputINIT() {
        setTimeout(() => {
            this.passwordInputinputINIT?.input?.nativeElement?.focus();
        });
    }
    focusPassword() {
        console.log('Focusing on confirm password input');

        setTimeout(() => {
            this.passwordInput?.input?.nativeElement?.focus();
        });
    }
    constructor(
        private http: HttpClient,
        private router: Router,
        private route: ActivatedRoute,
        private messageService: MessageService
    ) {}
    private destroy$ = new Subject<void>();
    ngOnInit() {
        setTimeout(() => {
            this.inputINIT();
        }, 400);
        this.route.queryParams.subscribe((params) => {
            this.email = params['email'] || '';
            this.oldPassword = params['password'] || ''; // Use oldPassword as login password
        });
        console.log(`Email: ${this.email}, Old Password: ${this.oldPassword}`);

        // Initialize any necessary data or state here
    }
    resetPassword() { this.loading = true;
        console.log('Reset Password initiated',this.loading);
        
        if (this.newPassword !== this.confirmPassword) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'New passwords do not match.',
                life: 4000
            });
            return;
        }
        console.log(`Resetting password for ${this.email}`);

       
        this.loaderMessageLine1 = 'Resetting Password...';
        this.loaderMessageLine2 = 'Please wait...';
        this.http
            .post(`${environment.authApiUrl}reset-password`, {
                email: this.email,
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                confirmPassword: this.confirmPassword
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (res: any) => {
                    this.loading = false;
                    console.log(res);

                    if (res) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Password reset successful.',
                            life: 4000
                        });
                        setTimeout(() => this.router.navigate(['/login']), 1500);
                    } else {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: res.message || 'Reset failed.',
                            life: 4000
                        });
                    }
                },
                error: (err) => {
                    this.loading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err.error?.message || 'Reset failed.',
                        life: 4000
                    });
                }
            });
    }
    ngOnDestroy(): void {
        // Signal all observables to complete and clean up subscriptions
        this.destroy$.next();
        this.destroy$.complete();
        console.log('ResetPasswordComponent destroyed');
    }
}
